import { render, staticRenderFns } from "./InitializationComponent.vue?vue&type=template&id=2938147e&scoped=true&"
import script from "./InitializationComponent.vue?vue&type=script&lang=js&"
export * from "./InitializationComponent.vue?vue&type=script&lang=js&"
import style0 from "./InitializationComponent.vue?vue&type=style&index=0&id=2938147e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2938147e",
  null
  
)

component.options.__file = "InitializationComponent.vue"
export default component.exports